import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import moment from 'moment';
import { ListItem } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import { SelectableList } from 'components';
import { clearLeadAdResults, getLeadAdResults } from 'redux/modules/ads';
import * as styles from './AdDetails.scss';
var AdDetailResults = (_dec = connect(function (state, ownProps) {
  return {
    leadAdResults: state.ads.leadAdResults,
    organization: state.organization.current,
    theme: state.theme
  };
}, {
  clearLeadAdResults: clearLeadAdResults,
  getLeadAdResults: getLeadAdResults
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AdDetailResults, _Component);

  var _super = _createSuper(AdDetailResults);

  function AdDetailResults(props) {
    var _this;

    _classCallCheck(this, AdDetailResults);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleListChange", function (val) {
      console.log('handleListChange()');
      console.log(val);

      _this.setState({
        listValue: val
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderResultItem", function () {
      var item = _this.props.leadAdResults[_this.state.listValue];
      return /*#__PURE__*/React.createElement("div", null, item.field_data.map(function (data, index) {
        var lastItem = index === item.field_data.length - 1;
        return /*#__PURE__*/React.createElement("div", {
          className: styles.resultItem,
          key: index,
          style: lastItem ? {
            borderBottom: 'none'
          } : {}
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.resultText,
          style: {
            textAlign: 'right'
          }
        }, _.startCase(data.name), ":"), data.values.map(function (value, valueIndex) {
          return /*#__PURE__*/React.createElement("span", {
            className: styles.resultText,
            key: valueIndex,
            style: {
              flex: '0 0 70%'
            }
          }, value);
        }));
      }));
    });

    _this.state = {
      listValue: 0
    };
    return _this;
  }
  /** *********************************************************
   LIFECYCLE METHODS
   ***********************************************************/


  _createClass(AdDetailResults, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.adDetails.insights && this.props.adDetails.insights.facebook && this.props.adDetails.insights.facebook.objective === 'LEAD_GENERATION') {
        this.props.getLeadAdResults(this.props.organization.id, this.props.adDetails.id);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.clearLeadAdResults();
    }
    /** *********************************************************
     CUSTOM METHODS
     ***********************************************************/

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          adDetails = _this$props.adDetails,
          leadAdResults = _this$props.leadAdResults,
          theme = _this$props.theme;
      var items = leadAdResults ? leadAdResults.map(function (lead, index) {
        return /*#__PURE__*/React.createElement(ListItem, {
          key: index,
          primaryText: moment(lead.created_time).format('M/D/YY - h:mm a'),
          value: index,
          style: {
            borderBottom: "1px solid ".concat(theme.colors.gray3)
          }
        });
      }) : null;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, leadAdResults && leadAdResults.length > 0 && /*#__PURE__*/React.createElement(SelectableList, {
        defaultValue: this.state.listValue,
        style: {
          padding: 0,
          borderRight: "1px solid ".concat(theme.colors.gray3),
          flex: '0 0 33%'
        },
        onChange: this.handleListChange
      }, items), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '0 0 67%',
          padding: 16
        }
      }, leadAdResults && leadAdResults.length > 0 ? this.renderResultItem() : /*#__PURE__*/React.createElement("h2", {
        style: {
          color: '#333',
          margin: 32
        }
      }, "No Results Found")));
    }
  }]);

  return AdDetailResults;
}(Component)) || _class);
export default AdDetailResults;